/**
 * Параметры для расчета размеров canvas
 */
export interface CalculateCanvasDimensionsParams {
    /**
     * Ширина медиа (если есть)
     */
    mediaWidth?: number
    /**
     * Высота медиа (если есть)
     */
    mediaHeight?: number
    /**
     * Ширина контейнера
     */
    containerWidth: number
    /**
     * Высота контейнера
     */
    containerHeight: number
    /**
     * Минимальная ширина canvas (по умолчанию)
     */
    minWidth: number
    /**
     * Минимальная высота canvas (по умолчанию)
     */
    minHeight: number
}

/**
 * Расчет размеров canvas с учетом пропорций медиа и размеров контейнера
 * Canvas масштабируется так, чтобы медиа полностью поместилось в контейнер
 *
 * @param params - параметры для расчета
 * @returns размеры canvas { width, height }
 */
export function calculateCanvasDimensions(
    params: CalculateCanvasDimensionsParams
): { width: number; height: number } {
    const {
        mediaWidth,
        mediaHeight,
        containerWidth,
        containerHeight,
        minWidth,
        minHeight,
    } = params

    // Если нет размеров медиа, используем размеры контейнера или минимальные размеры
    if (!mediaWidth || !mediaHeight) {
        return {
            width: Math.max(minWidth, containerWidth),
            height: Math.max(minHeight, containerHeight),
        }
    }

    // Рассчитываем размеры канваса пропорционально медиа, чтобы медиа полностью поместилось
    // Используем размеры контейнера как основу, без привязки к минимальным размерам
    const mediaAspectRatio = mediaWidth / mediaHeight
    const containerAspectRatio = containerWidth / containerHeight

    let canvasWidth: number
    let canvasHeight: number

    if (mediaAspectRatio > containerAspectRatio) {
        // Медиа шире - используем ширину контейнера
        canvasWidth = containerWidth
        canvasHeight = canvasWidth / mediaAspectRatio

        // Если высота превышает контейнер, ограничиваем по высоте
        if (canvasHeight > containerHeight) {
            canvasHeight = containerHeight
            canvasWidth = canvasHeight * mediaAspectRatio
        }
    } else {
        // Медиа выше (узкое/длинное) - используем высоту контейнера
        canvasHeight = containerHeight
        canvasWidth = canvasHeight * mediaAspectRatio

        // Если ширина превышает контейнер, ограничиваем по ширине
        if (canvasWidth > containerWidth) {
            canvasWidth = containerWidth
            canvasHeight = canvasWidth / mediaAspectRatio
        }
    }

    return { width: canvasWidth, height: canvasHeight }
}
